export default __webpack_public_path__ + "static/media/step1.04d18a85.png";